import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { Button, Card, Table, Text, Title } from '@bancobarigui/barihaus';

import { ColumnsType } from 'antd/es/table';
import { Space, Modal } from 'antd';

type Props<T extends Record<string, any> = any> = {
  title: string;
  emptyText: string;
  buttonTitle: string;
  dataSource: T[];
  handleAddNew: () => void;
  columns: ColumnsType<T>;
};

export function TableCard<T extends Record<string, any> = any>({
  title,
  columns,
  emptyText,
  dataSource,
  buttonTitle,
  handleAddNew,
}: Props<T>) {
  const processedColumns: ColumnsType<T> = columns.map((column) => {
    if (column.key === 'actions') {
      return {
        ...column,
        align: 'right' as const,
        width: 180,
        render: (_: any, record: T) => {
          const actions = column.render ? column.render(_, record, 0) : null;
          if (!actions || typeof actions !== 'object' || !('handleEdit' in actions)) return null;

          const typedActions = actions as { handleEdit: () => void; handleDelete: () => void };

          const confirmDelete = () => {
            Modal.confirm({
              title: 'Confirmar exclusão',
              content: 'Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.',
              okText: 'Remover',
              cancelText: 'Cancelar',
              icon: null,
              centered: true,
              okButtonProps: {
                style: {
                  backgroundColor: '#0090ff',
                  borderColor: '#0090ff',
                  color: '#fff',
                  boxShadow: 'none',
                },
              },
              cancelButtonProps: {
                style: {
                  backgroundColor: 'transparent',
                  borderColor: '#101010',
                  color: '#101010',
                  boxShadow: 'none',
                },
              },
              styles: {
                footer: {
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 12,
                },
              },
              onOk: () => typedActions.handleDelete(),
            });
          };

          return (
            <Space size="small">
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={typedActions.handleEdit}
                className="!p-0"
              >
                Editar
              </Button>
              <Button
                type="link"
                danger
                icon={<DeleteOutlined />}
                className="!p-0"
                onClick={confirmDelete}
              >
                Excluir
              </Button>
            </Space>
          );
        },
      };
    }
    return column;
  });

  return (
    <Card>
      <div className="flex justify-between items-center mb-4">
        <Title level={4}>{title}</Title>

        <Button
          buttonColor="primary"
          icon={<PlusOutlined />}
          onClick={handleAddNew}
        >
          {buttonTitle}
        </Button>
      </div>

      <div className="overflow-x-auto">
        <Table
          dataSource={dataSource as any}
          columns={processedColumns as any}
          locale={{
            emptyText: <Text className="text-gray-500">{emptyText}</Text>,
          }}
          pagination={false}
        />
      </div>
    </Card>
  );
}
